import { create } from "zustand"

import type { PreferenceAssociationItem } from "../hooks/useProductPreferenceAssociationList"

import type { ListCompanyProductAssociationsQuery } from "@/graphql/codegen/graphql"
import { ListCompanyProductAssociationsDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type PreferenceAssociationsFilters = SearchFilters & {
  companyId: string
  productId: number
}

const deduplicateAssociations = (
  newData: PreferenceAssociationItem[],
  existingData: PreferenceAssociationItem[]
): PreferenceAssociationItem[] => {
  const existingIds = new Set(
    existingData.map(
      (association) =>
        `${association.companyProductAssociationId}-${association.companyProductAssociationLocationId ?? "no-location"}`
    )
  )
  return [
    ...existingData,
    ...newData.filter(
      (association) =>
        !existingIds.has(
          `${association.companyProductAssociationId}-${association.companyProductAssociationLocationId ?? "no-location"}`
        )
    ),
  ]
}

export const useProductPreferenceAssociationsStore = create(
  createSearchStore<PreferenceAssociationItem, PreferenceAssociationsFilters, ListCompanyProductAssociationsQuery>({
    documentNode: ListCompanyProductAssociationsDocument,
    deduplicateData: deduplicateAssociations,
    getQueryInput: (filters, offset, limit) => ({
      companyId: filters.companyId,
      limit,
      offset,
      filter: { productId: filters.productId },
    }),
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: "CompanyProductAssociationLocationListResult",
      data: data.companyProductAssociation.list.items ?? [],
    }),
  })
)
